import { createFileRoute } from "@tanstack/react-router";
import { AuthDebug } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/auth/debug")({
  head: () => seoHead({ title: "Auth Session Debug", noindex: true }),
  component: AuthDebug,
});
